import { create } from "zustand"

/**
 * Commission range filter keys for Explore/Campaign pages
 */
export type CommissionRangeKey =
  | "NONE"
  | "LESS_THAN_3"
  | "3_TO_5"
  | "6_TO_10"
  | "11_TO_14"
  | "MORE_THAN_15"

/**
 * Maps commission range keys to API query parameters
 */
export const COMMISSION_RANGE_VALUE_MAP: Record<
  CommissionRangeKey,
  { startCommissionRate?: string; endCommissionRate?: string }
> = {
  NONE: {},
  LESS_THAN_3: { endCommissionRate: "3" },
  "3_TO_5": { startCommissionRate: "3", endCommissionRate: "5" },
  "6_TO_10": { startCommissionRate: "6", endCommissionRate: "10" },
  "11_TO_14": { startCommissionRate: "11", endCommissionRate: "14" },
  MORE_THAN_15: { startCommissionRate: "15" }
}

/**
 * Filter state for Explore/Campaign pages
 * Used for filtering campaigns by commission, order, and selfie requirement
 */
export type FilterExploreValues = {
  order: "ASC" | "DESC"
  isSelfFaceRequired: boolean | null
  commissionRange: CommissionRangeKey
}

interface FilterExploreState {
  filter: FilterExploreValues
  setFilter: (filter: FilterExploreValues) => void
  reset: () => void
  calculateFilterCount: () => number
}

export const DEFAULT_FILTER_EXPLORE: FilterExploreValues = {
  order: "DESC",
  isSelfFaceRequired: null,
  commissionRange: "NONE"
}

const createDefaultFilter = (): FilterExploreValues => ({
  ...DEFAULT_FILTER_EXPLORE
})

const calculateFilterCountInternal = (filter: FilterExploreValues): number => {
  let count = 0
  if (filter.order !== DEFAULT_FILTER_EXPLORE.order) count++
  if (filter.isSelfFaceRequired !== DEFAULT_FILTER_EXPLORE.isSelfFaceRequired) count++
  if (filter.commissionRange !== DEFAULT_FILTER_EXPLORE.commissionRange) count++

  return count
}

export const useFilterExplore = create<FilterExploreState>()((set, get) => ({
  filter: createDefaultFilter(),
  setFilter: (filter) => set({ filter: { ...filter } }),
  reset: () => set({ filter: createDefaultFilter() }),
  calculateFilterCount: () => calculateFilterCountInternal(get().filter)
}))
